module.exports = __webpack_public_path__ + "static/media/mercury.b4663129.png";